module.exports = __webpack_public_path__ + "static/Java-ec148ce2edc1cb55be656ed98ba2fc35.jpg";